import { render, staticRenderFns } from "./section-presentation.vue?vue&type=template&id=64f6f081&scoped=true"
import script from "./section-presentation.vue?vue&type=script&lang=js"
export * from "./section-presentation.vue?vue&type=script&lang=js"
import style0 from "./section-presentation.vue?vue&type=style&index=0&id=64f6f081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f6f081",
  null
  
)

export default component.exports